import { COLORS } from "../../../common/consts/colors";
import type { IconProps } from "./type";

export default function SpaWellnessIcon({ color = "lightblack" }: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M12 20C4 20 2 13.3333 2 10C3.78715 10 6.53246 10.5749 8.6948 12.3412M12 20C20 20 22 13.3333 22 10C20.2129 10 17.4675 10.5749 15.3052 12.3412M12 20C12 16.2892 13.4344 13.8693 15.3052 12.3412M12 20C12 16.2892 10.5656 13.8693 8.6948 12.3412M15.3052 12.3412C15.1752 9.15002 13.4251 5.42511 12 4C10.5749 5.42511 8.82483 9.15002 8.6948 12.3412"
        stroke={COLORS[color]}
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}
